import classNames from 'classnames';
import * as React from 'react';

import { LinkListProps } from './LinkList';
import { LinkListBackgroundVariant } from './LinkListBackgroundVariant.csharp';
import { LinkListColumnVariant } from './LinkListColumnVariant.csharp';
import LinkListItem from './LinkListItem';

export class LinkListWithColumns extends React.Component<LinkListProps> {
    render() {
        const { columnVariant, backgroundVariant, links } = this.props.model;

        const columnModifier = columnVariant == LinkListColumnVariant.FourColumns ? 'LinkListWithColumns--FourColumns' : 'LinkListWithColumns--TwoColumns';
        const backgroundModifier =
            columnVariant == LinkListColumnVariant.TwoColumns ? `LinkListWithColumns--${LinkListBackgroundVariant[backgroundVariant]}` : '';

        return (
            <div className={classNames('LinkListWithColumns', columnModifier, backgroundModifier)}>
                <div className="LinkListWithColumns__Inner">
                    <ul className="LinkListWithColumns__Items">
                        {links.map((link, index) => (
                            <li className="LinkListWithColumns__Item" key={index}>
                                <LinkListItem model={link} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}
